/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Build_OverlineInputs */

const en_mk_build_overline = /** @type {(inputs: Mk_Build_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YOUR WAY TO BUILD`)
};

const id_mk_build_overline = /** @type {(inputs: Mk_Build_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CARA MEMBANGUN`)
};

/**
* | output |
* | --- |
* | "YOUR WAY TO BUILD" |
*
* @param {Mk_Build_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_build_overline = /** @type {((inputs?: Mk_Build_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Build_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_build_overline(inputs)
	return en_mk_build_overline(inputs)
});